import * as Actions from "./_ActionTypes";
import * as Pre from "./_PreActionNames";
const _preActionName = Pre.AIR_CONDITIONER;
// export function SwitchOn(deviceId) {
//     return {
//         type: _preActionName + Actions.SWITCH_ON,
//         payload: { deviceId }
//     }
// }

// export function SwitchOff(deviceId) {
//     return {
//         type : _preActionName + Actions.SWITCH_OFF,
//         payload : {deviceId}
//     }
// }

/**
 *  will turn on/off device
 * @param {*} deviceId
 * @param {*} value
 * @param {*} accessToken
 */
export function ToggleSwitch(deviceId, value, accessToken) {
  return {
    type: Pre.AIR_CONDITIONER + Actions.TOGGLE_SWITCH,
    accessToken,
    payload: { deviceId, value },
    socket: { send: true, keepSocket: true },
  };
}

export function Increase(deviceId, accessToken) {
  return {
    type: Pre.AIR_CONDITIONER + Actions.DIMMER_INCREASE,
    accessToken,
    payload: { deviceId },
    socket: { send: true, keepSocket: true },
  };
}

export function Decrease(deviceId, accessToken) {
  return {
    type: Pre.AIR_CONDITIONER + Actions.DIMMER_DECREASE,
    accessToken,
    payload: { deviceId },
    socket: { send: true, keepSocket: true },
  };
}

export function turnOn(deviceId, deviceUId, accessToken) {
  var payload = { deviceId, deviceUId, value: true };
  return {
    type: _preActionName + Actions.UPDATE_VALUE,
    accessToken: accessToken,
    payload,
    socket: { send: true, keepSocket: true },
  };
}

export function turnOff(deviceId, deviceUId, accessToken) {
  var payload = { deviceId, deviceUId, value: false };

  return {
    type: _preActionName + Actions.UPDATE_VALUE,
    accessToken: accessToken,
    payload,
    socket: { send: true, keepSocket: true },
  };
}

export function changeThermostatFanMode(
  deviceId = 0,
  deviceUId = null,
  fanModeValue,
  accessToken
) {
  var payload = { deviceId, deviceUId, fanModeValue };
  return {
    type: _preActionName + Actions.UPDATE_THERMOSTAT_FAN_MODE,
    accessToken: accessToken,
    payload,
    socket: { send: true, keepSocket: true },
  };
}

export function changeThermostatMode(
  deviceId = 0,
  deviceUId = null,
  modeValue,
  economyEnabled,
  accessToken
) {
  var payload = { deviceId, deviceUId, modeValue, economyEnabled };
  return {
    type: _preActionName + Actions.UPDATE_THERMOSTAT_MODE,
    accessToken: accessToken,
    payload,
    socket: { send: true, keepSocket: true },
  };
}

export function changeSetPoint(
  deviceId = 0,
  deviceUId = null,
  value,
  accessToken
) {
  var payload = { deviceId, deviceUId, value };

  return {
    type: _preActionName + Actions.UPDATE_SET_POINT,
    accessToken: accessToken,
    payload,
    socket: { send: true, keepSocket: true },
  };
}

// deviceId : id of device
// temperature : new temperature to set on device
// export function ChangeTemperature(deviceId , temperature) {
//     return {
//         type : _preActionName + Actions.DIMMER_CHANGE_VALUE,
//         payload : {deviceId , value : temperature}
//     }
// }
